<template>
    <div class="container">
        <div class="button" @click="addToCart">
            <div class="getStarted">{{this.message}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "AddToCartButton",
    props: {
        message: String ,
        selectedSize: String,
        selectedColor: Object,
        productID: Number,
    },
    methods: {
        addToCart(){
        }
    }

};
</script>
  
<style scoped>
.backgroundComponent {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0%;
    right: 0%;
    bottom: 0%;
    left: 0%;
    background-color: rgba(255, 255, 255, 0.7);
}

.sizeTitle {
    position: relative;
    line-height: 22px;
}

.elementsswatchessinglebutto {
    border: 1px solid #121212;
    box-sizing: border-box;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 15px;
}

.sizeBox {
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 15px;
}

.groupButtons {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.boxesWrapper {
    position: absolute;
    height: 73.08%;
    width: 92.93%;
    top: 13.46%;
    right: 3.53%;
    bottom: 13.46%;
    left: 3.53%;
}

.container {
    position: relative;
    width: 100%;
    height: 52px;
    text-align: center;
    font-size: 14px;
    color: #121212;
}

.getStarted {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 32px;
    font-weight: 500;
}

.button {
    position: relative;
    background-color: #121212;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 26px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    color: #fff;
    font-family: 'Space Grotesk';
    cursor: pointer;
}
</style>